'use strict';

module.exports = {
    'how-it-works-video-modal' : function () {
        $('body').on('click', '.how-it-works-video-modal', function(e) {
            e.preventDefault();
            var url = $(this).attr('href');
            $('#youtubeModal .modal-body').html('<iframe src="'+ url +'" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
            $('#youtubeModal').modal('show');
        });
    }
};
